import { render, staticRenderFns } from "./blacklist.vue?vue&type=template&id=dea69ef8"
import script from "./blacklist.vue?vue&type=script&lang=ts"
export * from "./blacklist.vue?vue&type=script&lang=ts"
import style0 from "./blacklist.vue?vue&type=style&index=0&id=dea69ef8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports